import { apiAction } from "../models/requests";

const appendTokenName = (data) => {
    return data;
};

export function createLdap(userData) {
    if (window.disableAPIActiveState == undefined || window.disableAPIActiveState == 0) { localStorage.setItem("unActiveStateSec", new Date().getTime()); }
    let data = {};
    data.target_ldap_config = userData;
    appendTokenName(data);
    return apiAction({
        types: ["CREATE_LDAP_REQUESTED", "CREATE_LDAP_SUCCESS", "CREATE_LDAP_FAILED"],
        method: "POST",
        path: "admin/create_ldap_config",
        body: data
    });
}

export function getLdapId(ldapId) {
    if (window.disableAPIActiveState == undefined || window.disableAPIActiveState == 0) { localStorage.setItem("unActiveStateSec", new Date().getTime()); }
    let data = {};
    data.target_ldap_config = {"ldap_id": ldapId};
    appendTokenName(data);
    return apiAction({
        types: ["GET_LDAP_ID_REQUESTED", "GET_LDAP_ID_SUCCESS", "GET_LDAP_ID_FAILED"],
        method: "POST",
        path: "admin/get_ldap_config",
        body: data
    });
}


export function getLdap() {
    if (window.disableAPIActiveState == undefined || window.disableAPIActiveState == 0) { localStorage.setItem("unActiveStateSec", new Date().getTime()); }
    let data = {};
    appendTokenName(data);
    return apiAction({
        types: ["GET_LDAP_REQUESTED", "GET_LDAP_SUCCESS", "GET_LDAP_FAILED"],
        method: "POST",
        path: "admin/get_ldap_configs",
        body: data
    });
}

export function updateLdap(userData) {
    if (window.disableAPIActiveState == undefined || window.disableAPIActiveState == 0) { localStorage.setItem("unActiveStateSec", new Date().getTime()); }
    let data = {};
    data.target_ldap_config = userData;
    appendTokenName(data);
    return apiAction({
        types: ["UPDATE_LDAP_REQUESTED", "UPDATE_LDAP_SUCCESS", "UPDATE_LDAP_FAILED"],
        method: "POST",
        path: "admin/update_ldap_config ",
        body: data
    });
}

export function deleteLdap(ldapId) {
    if (window.disableAPIActiveState == undefined || window.disableAPIActiveState == 0) { localStorage.setItem("unActiveStateSec", new Date().getTime()); }
    let data = {};
    data.target_ldap_config = {"ldap_id": ldapId};
    appendTokenName(data);
    return apiAction({
        types: ["DELETE_LDAP_REQUESTED", "DELETE_LDAP_SUCCESS", "DELETE_LDAP_FAILED"],
        method: "POST",
        path: "admin/delete_ldap_config",
        body: data
    });
}

export function testLdapConfig(data){
    if (window.disableAPIActiveState == undefined || window.disableAPIActiveState == 0) { localStorage.setItem("unActiveStateSec", new Date().getTime()); }
    let postData = {};
    postData.target_ldap_config = {"ldap_id": data.ldapId};
    postData.target_user = {"username": data.username, "password" : data.password};
    appendTokenName(postData); 
    return apiAction({
        types: ["TEST_LDAP_CONFIG_REQUESTED", "TEST_LDAP_CONFIG_SUCCESS", "TEST_LDAP_CONFIG_FAILED"],
        method: "POST",
        path: "admin/test_ldap_config",
        body: postData
    });
}


// WEBPACK FOOTER //
// ./src/actions/actionLdap.js